import { Component, ViewEncapsulation, OnInit, ChangeDetectorRef, ViewChild, ElementRef, QueryList, ViewChildren } from "@angular/core";
import { NbAuthService } from "@nebular/auth";
import { Router, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { StorageService } from "../../../../shared/services/storage.service";
import { AccountDataService } from "../service/account-data.service";
import { ConfirmeCodigoCommand } from "../models/command/ConfirmeCodigoCommand";

@Component({
  selector: 'ngx-verify-code',
  styleUrls: ['./verify-code.component.scss'],
  templateUrl: './verify-code.component.html',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'full-screen-verify-code'
  }
})
export class NgxVerifyCodeComponent implements OnInit {
  @ViewChild('verifyCodeContainer', { static: true }) verifyCodeContainer: ElementRef;
  @ViewChild('codeInput1', { static: false }) codeInput1: ElementRef;
  @ViewChild('codeInput2', { static: false }) codeInput2: ElementRef;
  @ViewChild('codeInput3', { static: false }) codeInput3: ElementRef;
  @ViewChild('codeInput4', { static: false }) codeInput4: ElementRef;
  @ViewChild('codeInput5', { static: false }) codeInput5: ElementRef;
  @ViewChild('codeInput6', { static: false }) codeInput6: ElementRef;
  
  user: any = {
    email: ''
  };
  
  code: string[] = ['', '', '', '', '', ''];
  inputValues: string[] = ['', '', '', '', '', '']; // Array separado para os inputs
  submitted = false;
  errors: string[] = [];
  messages: string[] = [];
  showMessages = {
    error: false,
    success: false
  };
  strategy = 'email';

  constructor(
    private authService: NbAuthService,
    private cd: ChangeDetectorRef,
    private router: Router,
    private http: HttpClient,
    private storageService: StorageService,
    private accountDataService: AccountDataService
  ) {}

  ngOnInit() {
    console.log('verify-code ngOnInit iniciado');
    
    // Proteção contra redirecionamento automático do Nebular
    // Forçar que o usuário permaneça nesta tela
    this.preventNebularRedirect();
    
    // Proteção adicional: desabilitar logout automático do Nebular
    this.disableNebularAutoLogout();
    
    // Proteção contra navegação para logout
    this.preventLogoutNavigation();
    
    // Remove qualquer layout padrão do Nebular
    this.removeNebularLayout();
    
    // Carregar email do localStorage (método seguro)
    this.loadResetPasswordEmail();
    
    this.cd.detectChanges();
    console.log('verify-code ngOnInit concluído');
  }

  // Método para prevenir redirecionamento automático do Nebular
  private preventNebularRedirect() {
    // Forçar que a rota atual seja mantida
    const currentUrl = this.router.url;
    console.log('URL atual:', currentUrl);
    
    // Se não estiver na tela verify-code, redirecionar para ela
    if (!currentUrl.includes('verify-code')) {
      console.log('Forçando permanência na tela verify-code');
      this.router.navigate(['/auth/verify-code']);
    }
  }

  ngAfterViewInit() {
    console.log('verify-code ngAfterViewInit iniciado');
    // Garante que o componente ocupe toda a tela
    this.ensureFullScreen();
    
    // Focar no primeiro input
    setTimeout(() => {
      const firstInput = this.codeInput1;
      if (firstInput) {
        firstInput.nativeElement.focus();
      }
    }, 100);
    console.log('verify-code ngAfterViewInit concluído');
  }

  removeNebularLayout() {
    // Remove classes e estilos padrão do Nebular
    const body = document.body;
    body.classList.add('custom-verify-code-layout');
    
    // Remove qualquer container padrão do Nebular
    const nebularContainers = document.querySelectorAll('.nb-auth, .auth-block, .auth-container');
    nebularContainers.forEach(container => {
      if (container instanceof HTMLElement) {
        container.style.display = 'none';
      }
    });
  }

  ensureFullScreen() {
    // Garante que o componente ocupe toda a tela
    if (this.verifyCodeContainer) {
      const container = this.verifyCodeContainer.nativeElement;
      container.style.width = '100vw';
      container.style.height = '100vh';
      container.style.position = 'fixed';
      container.style.top = '0';
      container.style.left = '0';
      container.style.zIndex = '9999';
    }
  }

  loadResetPasswordEmail() {
    console.log('verify-code loadResetPasswordEmail iniciado');
    const resetPasswordEmail = this.storageService.getLocalItem('resetPasswordEmail');
    
    if (resetPasswordEmail) {
      this.user.email = resetPasswordEmail;
      console.log('Email carregado com sucesso para verificação de código:', resetPasswordEmail);
    } else {
      console.log('Nenhum email encontrado para verificação de código');
      // Se não encontrar email, redirecionar para request-password
      setTimeout(() => {
        console.log('Redirecionando para request-password (sem email)');
        this.router.navigate(['/auth/request-password']);
      }, 2000);
    }
    console.log('verify-code loadResetPasswordEmail concluído');
  }

  // Método para desabilitar logout automático do Nebular
  private disableNebularAutoLogout() {
    // Tentar desabilitar comportamentos automáticos do Nebular
    try {
      // Verificar se o authService tem métodos para controlar logout
      if (this.authService && typeof this.authService.logout === 'function') {
        console.log('AuthService detectado, tentando desabilitar logout automático');
      }
      
      // Adicionar listener para prevenir navegação indesejada
      this.router.events.subscribe(event => {
        if (event instanceof NavigationStart) {
          const url = event.url;
          if (url && url.includes('/auth/logout')) {
            console.log('Tentativa de logout detectada, cancelando...');
            // Não podemos cancelar NavigationStart, mas podemos registrar
            console.log('Bloqueando navegação para logout');
          }
        }
      });
      
    } catch (error) {
      console.log('Erro ao configurar proteção contra logout:', error);
    }
  }

  // Método para proteger contra navegações indesejadas para logout
  private preventLogoutNavigation() {
    // Proteção usando window.history
    const originalPushState = history.pushState;
    const originalReplaceState = history.replaceState;
    
    history.pushState = function(...args) {
      const url = args[2] as string;
      if (url && url.includes('/auth/logout')) {
        console.log('Tentativa de pushState para logout bloqueada:', url);
        return;
      }
      return originalPushState.apply(history, args);
    };
    
    history.replaceState = function(...args) {
      const url = args[2] as string;
      if (url && url.includes('/auth/logout')) {
        console.log('Tentativa de replaceState para logout bloqueada:', url);
        return;
      }
      return originalReplaceState.apply(history, args);
    };
    
    // Proteção usando router events
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        const url = event.url;
        if (url && url.includes('/auth/logout')) {
          console.log('Tentativa de navegação para logout detectada:', url);
          // Não forçar permanência na tela verify-code
        }
      }
    });
  }

  // Método para obter input por índice
  private getInputByIndex(index: number): ElementRef | null {
    switch (index) {
      case 0: return this.codeInput1;
      case 1: return this.codeInput2;
      case 2: return this.codeInput3;
      case 3: return this.codeInput4;
      case 4: return this.codeInput5;
      case 5: return this.codeInput6;
      default: return null;
    }
  }

  // Método para lidar com a digitação no código
  onCodeInput(event: any, index: number) {
    const value = event.target.value;
    
    // Permitir apenas números
    if (!/^\d*$/.test(value)) {
      this.inputValues[index] = '';
      this.code[index] = '';
      return;
    }
    
    // Atualizar ambos os arrays
    this.inputValues[index] = value;
    this.code[index] = value;
    
    // Se digitou um número, ir para o próximo campo
    if (value && index < 5) {
      setTimeout(() => {
        const nextInput = this.getInputByIndex(index + 1);
        if (nextInput) {
          nextInput.nativeElement.focus();
        }
      }, 10);
    }
    
    // Se preencheu todos os campos, tentar verificar automaticamente
    if (this.code.every(digit => digit !== '')) {
      setTimeout(() => {
        this.verifyCode();
      }, 500);
    }
  }

  // Método para lidar com o backspace
  onCodeKeydown(event: any, index: number) {
    if (event.key === 'Backspace') {
      // Se o campo atual está vazio, voltar para o anterior
      if (!this.inputValues[index] && index > 0) {
        const prevInput = this.getInputByIndex(index - 1);
        if (prevInput) {
          prevInput.nativeElement.focus();
          this.inputValues[index - 1] = '';
          this.code[index - 1] = '';
        }
      } else {
        // Limpar o campo atual
        this.inputValues[index] = '';
        this.code[index] = '';
      }
    } else if (event.key === 'ArrowLeft' && index > 0) {
      const prevInput = this.getInputByIndex(index - 1);
      if (prevInput) {
        prevInput.nativeElement.focus();
      }
    } else if (event.key === 'ArrowRight' && index < 5) {
      const nextInput = this.getInputByIndex(index + 1);
      if (nextInput) {
        nextInput.nativeElement.focus();
      }
    }
  }

  // Método para colar código
  onCodePaste(event: any) {
    event.preventDefault();
    const pasteData = event.clipboardData.getData('text');
    const digits = pasteData.replace(/\D/g, '').slice(0, 6);
    
    // Limpar todos os campos primeiro
    this.inputValues = ['', '', '', '', '', ''];
    this.code = ['', '', '', '', '', ''];
    
    // Preencher com os dígitos colados
    for (let i = 0; i < 6; i++) {
      if (digits[i]) {
        this.inputValues[i] = digits[i];
        this.code[i] = digits[i];
      }
    }
    
    // Se colou um código completo, verificar automaticamente
    if (digits.length === 6) {
      setTimeout(() => {
        this.verifyCode();
      }, 500);
    }
  }

  // Método para reenviar código
  resendCode(): void {
    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    console.log('Reenviando código para:', this.user.email);

    // Usar o authService para reenviar o código (mesmo serviço usado no reset-password)
    this.authService.requestPassword(this.strategy, { email: this.user.email }).subscribe({
      next: (result: any) => {
        console.log('Resposta da API RequestPassword (reenvio):', result);
        this.submitted = false;
        
        if (result.isSuccess()) {
          this.messages = ['Novo código enviado com sucesso! Verifique seu e-mail.'];
          this.showMessages.success = true;
          
          // NÃO limpar os campos - manter os inputs visíveis
          // this.inputValues = ['', '', '', '', '', ''];
          // this.code = ['', '', '', '', '', ''];
          
          // Apenas focar no primeiro input para nova tentativa
          setTimeout(() => {
            if (this.codeInput1) {
              this.codeInput1.nativeElement.focus();
            }
          }, 100);
        } else {
          const originalErrors = result.getErrors();
          this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          this.showMessages.error = true;
        }
        
        this.cd.detectChanges();
      },
      error: (error) => {
        console.log('Erro ao reenviar código:', error);
        this.submitted = false;
        this.errors = ['Erro ao reenviar código. Tente novamente.'];
        this.showMessages.error = true;
        
        // Em caso de erro, manter o código atual para não perder o que já foi digitado
        this.cd.detectChanges();
      }
    });
  }

  // Método para verificar se o código está completo
  isCodeComplete(): boolean {
    return this.inputValues.every(digit => digit !== '');
  }

  // Método para verificar código
  verifyCode(): void {
    this.submitted = true;
    this.errors = [];
    this.messages = [];
    this.showMessages.error = false;
    this.showMessages.success = false;

    const fullCode = this.code.join('');

    // Validação básica
    if (fullCode.length !== 6) {
      this.errors = ['Por favor, digite o código completo de 6 dígitos.'];
      this.showMessages.error = true;
      this.submitted = false;
      this.cd.detectChanges();
      return;
    }

    // Usar o serviço original, mas com tratamento especial para evitar logout
    const confirmeCodigoCommand = new ConfirmeCodigoCommand({
      email: this.user.email,
      codigoVerificadorEmail: this.code.join('')
    });

    console.log('Enviando requisição para confirme-codigo:', confirmeCodigoCommand);

    // Usar o serviço customizado, mas com tratamento especial para evitar logout
    this.accountDataService.ConfirmeCodigo(confirmeCodigoCommand).subscribe({
      next: (result: any) => {
        console.log('Resposta da API ConfirmeCodigo:', result);
        this.submitted = false;
        
        if (result.codigoConfirmado === true) {
          console.log('Código confirmado com sucesso! Redirecionando para new-password...');
          this.messages = ['Código verificado com sucesso! Redirecionando...'];
          this.showMessages.success = true;
          
          // Salvar que o código foi verificado
          this.storageService.setLocalItem('codeVerified', 'true');
          
          // Redirecionar para a tela de nova senha APÓS receber o sucesso
          setTimeout(() => {
            console.log('Executando redirecionamento para /auth/new-password');
            this.router.navigate(['/auth/new-password']);
          }, 2000);
          
          this.cd.detectChanges();
        } else {
          console.log('Código NÃO confirmado. Mantendo usuário na tela verify-code...');
          console.log('Resultado completo:', result);
          
          // Garantir que o usuário permaneça na tela verify-code
          // Não fazer nenhum redirecionamento
          
          if (result.getErrors && result.getErrors()) {
            const originalErrors = result.getErrors();
            this.errors = originalErrors.map((error: string) => this.translateErrorMessage(error));
          } else {
            this.errors = ['Código inválido. Verifique e tente novamente.'];
          }
          
          this.showMessages.error = true;
          
          // Limpar os campos para nova tentativa
          this.inputValues = ['', '', '', '', '', ''];
          this.code = ['', '', '', '', '', ''];
          
          // Focar no primeiro input para nova tentativa
          setTimeout(() => {
            if (this.codeInput1) {
              this.codeInput1.nativeElement.focus();
            }
          }, 100);
          
          this.cd.detectChanges();
        }
      },
      error: (error) => {
        console.log('Erro na API ConfirmeCodigo:', error);
        this.submitted = false;
        this.errors = ['Erro ao verificar código. Tente novamente.'];
        this.showMessages.error = true;
        
        // Garantir que o usuário permaneça na tela verify-code mesmo em caso de erro
        // Limpar os campos para nova tentativa
        this.inputValues = ['', '', '', '', '', ''];
        this.code = ['', '', '', '', '', ''];
        
        // Focar no primeiro input para nova tentativa
        setTimeout(() => {
          if (this.codeInput1) {
            this.codeInput1.nativeElement.focus();
          }
        }, 100);
        
        this.cd.detectChanges();
      }
    });
  }

  // Método para voltar ao request-password
  goBackToRequestPassword(): void {
    // Salvar email novamente antes de voltar
    this.storageService.setLocalItem('resetPasswordEmail', this.user.email);
    this.router.navigate(['/auth/request-password']);
  }

  // Método para voltar ao login
  goBackToLogin(): void {
    // Limpar dados do localStorage
    this.storageService.removeLocalItem('resetPasswordEmail');
    this.storageService.removeLocalItem('codeVerified');
    this.router.navigate(['/auth/login']);
  }

  /**
   * Traduz mensagens de erro do inglês para português
   */
  private translateErrorMessage(error: string): string {
    const errorTranslations: { [key: string]: string } = {
      'Invalid verification code': 'Código de verificação inválido',
      'Code expired': 'Código expirado',
      'Code already used': 'Código já foi utilizado',
      'Email is required': 'E-mail é obrigatório',
      'Invalid email format': 'Formato de e-mail inválido',
      'User not found': 'Usuário não encontrado',
      'Account is locked': 'Conta está bloqueada',
      'Account is disabled': 'Conta está desabilitada',
      'Too many failed attempts': 'Muitas tentativas falharam',
      'Session expired': 'Sessão expirada',
      'Network error': 'Erro de conexão',
      'Server error': 'Erro do servidor'
    };

    // Procura por uma tradução exata
    if (errorTranslations[error]) {
      return errorTranslations[error];
    }

    // Procura por traduções parciais
    for (const [english, portuguese] of Object.entries(errorTranslations)) {
      if (error.toLowerCase().includes(english.toLowerCase())) {
        return portuguese;
      }
    }

    // Se não encontrar tradução, retorna a mensagem original
    return error;
  }

  getConfigValue(key: string): any {
    return true;
  }
}
